import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { v4 as uuidv4 } from 'uuid';
import cn from 'classnames';
import { useTranslation } from '../../src/i18n';
import { TP } from '../../constants/consts';
import FormikAutocompleteSelect from '../Fields/FormikAutocompleteSelect';

const useStyles = makeStyles(theme => ({
  box: {
    display: 'flex',
    alignItems: 'center',
  },
  field: {
    marginLeft: theme.spacing(1),
    width: 100,
  },
}));

const PublicPrivateSwitcher = ({ onChange, options, value, key, labelClassName, rootClassName }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={cn(classes.box, rootClassName)}>
      <span className={labelClassName}>{t(`${TP}.FN_DISPLAY`)}</span>
      <div className={classes.field}>
        <FormikAutocompleteSelect
          options={options}
          field={{ name: `${key}-visibility`, value: value || options[0] }}
          onChange={v => {
            onChange(v);
          }}
          instanceId={uuidv4()}
        />
      </div>
    </div>
  );
};

PublicPrivateSwitcher.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  options: PropTypes.array,
  key: PropTypes.string,
  labelClassName: PropTypes.string,
  rootClassName: PropTypes.string,
};

PublicPrivateSwitcher.defaultProps = {
  value: null,
  options: [],
  key: 'uniq',
  labelClassName: '',
  rootClassName: '',
};

export default memo(PublicPrivateSwitcher);
